import { CalendarInput, getCalendarInput, getTimeFormat, LocaleTimeCalendarInput } from "common/utils/date-utils"


const countryLocaleMap = {
  AU: "en-AU",
  GB: "en-GB",
  NZ: "en-NZ",
  SG: "en-SG",
}


function getLocaleString(countryCode: string): string {

  // @ts-ignore
  const locale = countryLocaleMap[countryCode] || "";

  return locale.toLowerCase();

}

function getCountryCode () {

  return localStorage.getItem('country_iso2')||"";
}

export interface UserSetting {
  language: string;
  countryCode: string;
  locale: string;
  timeZone: string;
  timeFormat: string;
  calendarInput: CalendarInput;
  calendarInitialView: "dayGridDay" | "dayGridWeek";
}

export function getUserSetting(): UserSetting {

  const countryCode = getCountryCode();
  const locale = getLocaleString(countryCode);
  const timeFormat = getTimeFormat(locale);
  const calendarInput = getCalendarInput(locale);

  return {
    language: "en",
    countryCode: countryCode,
    locale: locale,
    timeZone: "UTC",
    timeFormat: timeFormat,
    calendarInput: calendarInput,
    calendarInitialView: "dayGridWeek",
  };
}